import { Seo } from "../components/Seo";
import { Link, useNavigate } from "../components/Layout";
export default function NotFound(){const navigate=useNavigate();return <main><Seo path="/404" /><section className="legal"><h1>페이지를 찾을 수 없습니다</h1><p>주소를 확인하거나 홈으로 돌아가 주세요.</p><Link className="button wine" href="/" navigate={navigate}>홈으로 이동</Link></section></main>}
